enum SidebarState {
  HIDDEN = 'hide',
  COLLAPSED = 'collapsed',
  FULL = 'full',
}
export default SidebarState;
